export const consentTypes = ['ad_storage', 'ad_user_data',  'ad_personalization',  'analytics_storage',  'functionality_storage',  'personalization_storage',  'security_storage' ] as const

export type ConsentType = typeof consentTypes[number]
export type ConsentChoice = 'denied' | 'granted'

export type ConsentMapping<CookieTypes extends string> = {
  [Key in CookieTypes]: ConsentType[]
}

export type FullConsentUpdate = { [Key in ConsentType]: ConsentChoice }

/**
 * Send consent updates based on a cookie type and a mapping between cookie types and consent types
 *
 * @param mapping Curried argument: maps between site specific cookies and consent types
 * @param cookie Site specific cookie that triggers an update to consent
 * @param isAccepted Whether the site specific cookie is accepted or not
 */
export const updateConsentMode = <CookieType extends string>(mapping: ConsentMapping<CookieType>) => (cookie: CookieType, isAccepted: boolean) => {
  const modes = mapping[cookie]
  modes.forEach(mode => pushConsent(mode, isAccepted ? 'granted' : 'denied'))
}

function gtag(..._: any[]) {
  const dataLayer = (window as any).dataLayer
  if (dataLayer) {
    dataLayer.push(arguments)
  } else {
    console.log("DataLayer not found, failed to push event", arguments)
  }
}

const pushConsent: (consentType: ConsentType, choice: ConsentChoice) => void = (cType, cChoice) => {
  const selection = { [cType]: cChoice }
  gtag('consent', 'update', selection)
}

export const pushAllConsentTypes: (update: FullConsentUpdate) => void = (update) => {
  gtag('consent', 'update', update)
}

export const pushIframeEvent: (eventName: string, eventData: any) => void = (eventName, eventData) => {
  gtag('event', eventName, eventData)
}

export const grantAllConsentTypes = () => pushAllConsentTypes({
  'ad_storage': 'granted',
  'ad_user_data': 'granted',
  'ad_personalization': 'granted',
  'analytics_storage': 'granted',
  'functionality_storage': 'granted',
  'personalization_storage': 'granted',
  'security_storage': 'granted'
})

export const grantMinimalConsentTypes = () => pushAllConsentTypes({
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'analytics_storage': 'granted',
  'functionality_storage': 'granted',
  'personalization_storage': 'denied',
  'security_storage': 'denied'
})
